import { useMemo, useState } from 'react';
import AuthContext from '../context/AuthContext';
import { AuthData } from '../Models/Users/authData';
const AuthProvider = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  const [auth, setAuth] = useState<AuthData>();
  const setAuthInfo = (actions: string[]) => {
    const authData: AuthData = {
      actions: actions,
    };
    setAuth(authData);
  };
  const isAuthorized = (action: string) => {
    if (auth?.actions == null) return null;
    return !!auth?.actions.find((a) => a === action);
  };
  return (
    <AuthContext.Provider
      value={useMemo(() => ({
        auth: auth,
        setAuth: (actions: string[]) => setAuthInfo(actions),
        isAuthorized,
      }), [auth, isAuthorized])}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
